import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

interface ChevronIconProps {
    dir?: "left" | "right" | "up" | "down";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChevronIcon',
  props: {
    dir: { default: "left" }
  },
  setup(__props: any) {

const props = __props as { dir: "left" | "right" | "up" | "down" };



const directionClass = computed(() => {
    return `chevron--${props.dir}`;
});

return { __sfc: true,props, directionClass }
}

})